module.exports = __webpack_public_path__ + "images/446bf442.png";